export default __webpack_public_path__ + "static/media/notification.6477e968.svg";